import { Container, Grid, Tab, Tabs } from '@mui/material';
import React, { useMemo, useState } from 'react'; // Import useMemo
import { useSelector } from 'react-redux';
import OperatorStatsTab from './OperatorStatsTab.jsx';
import OverviewTab from './OverviewTab.jsx';
import PerformanceTab from './PerformanceTab.jsx';
import TicketsStatsTab from './TicketsStatsTab.jsx';

const StatsPage = () => {
  const profile = useSelector((state) => state?.login?.profile);
  const [value, setValue] = useState(1);

  const allowedEmails = [
    'johansebbane@hoortrade.com',
    'julienpelisson@hoortrade.com',
    'leopoldassogba@hoortrade.com',
    'justforiel@hoortrade.com',
    'romainlaval@hoortrade.com',
    'loicgranet@hoortrade.com',
    'theocuadrado@hoortrade.com',
    'romaincharalambos@hoortrade.com',
    'laveniyabossuge@hoortrade.com',
    'valentinbastianon@hoortrade.com',
    'jeanphilippejanier@hoortrade.com',
    'romaneazzis@hoortrade.com',
  ];

  const checkAccessToSensitiveDatas = () => {
    return profile?.email && allowedEmails.includes(profile.email);
  };

  const sensitiveDataAllowedToUser = checkAccessToSensitiveDatas();

  // Use useMemo to define pages array
  const pages = useMemo(
    () => [
      {
        value: 1,
        name: 'Overview',
        content: <OverviewTab key={1} />,
        tab: <Tab key={1} value={1} label="Overview" />,
      },
      {
        value: 2,
        name: 'OperatorStats',
        content: <OperatorStatsTab key={2} />,
        tab: <Tab key={2} value={2} label="Suivi des opérateurs" />,
      },
      {
        value: 3,
        name: 'Performance',
        content: <PerformanceTab key={3} />,
        tab: (
          <Tab
            key={3}
            value={3}
            label="Performance des opérateurs"
            disabled={!allowedEmails.includes(profile?.email)} // Use profile here
          />
        ),
      },
      {
        value: 4,
        name: 'TicketsStats',
        content: <TicketsStatsTab key={4} />,
        tab: <Tab key={4} value={4} label="Activité des tickets" />,
      },
    ],
    [profile?.email]
  ); // Dependency array:  re-create pages only when profile?.email changes

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Grid container direction="row" spacing={1} sx={{ position: 'relative' }}>
        <Grid size={1}>
          <Tabs
            value={value}
            onChange={handleChange}
            orientation="vertical"
            variant="fullWidth"
            sx={{ position: 'sticky', width: '160%', top: 65 }}
          >
            {pages.map((page) => page?.tab)}
          </Tabs>
        </Grid>
        <Grid size={11}>
          <Container>
            {pages?.map((page) => {
              if (page?.value === value) {
                return React.cloneElement(page.content, {
                  setValue: setValue,
                  sensitiveDataAllowedToUser: sensitiveDataAllowedToUser,
                });
              }
            })}
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default StatsPage;
